import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Product } from 'services/action';

import { Page, Button } from 'ui/components';

import { FormUnit, FormInput } from './component/form';

const initialState = {
  ready: false,
  product: null,
  units: null,
  form: null,
  price: null,
};

const UpdateScreen = ({ match }) => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const [{ ready, product, units, form, price }, setState] =
    React.useState(initialState);

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };

  const $handleUnitChange = (v) => {
    setState((prevState) => ({ ...prevState, units: v }));
  };

  const $handleSubmit = async () => {
    const payload = {
      ...form,
      ...units,
      ...price,
    };

    const submit = await Dispatch(Product.$update(product?.id, payload));

    if (submit?.message === 'success') {
      History.replace(`/master/product/${submit?.data?.id}`);
    }
  };

  React.useEffect(() => {
    const $onLoad = async (id) => {
      const req = await Dispatch(Product.$show(id));

      if (req?.message === 'success' && req?.data !== null) {
        setState((prevState) => ({
          ...prevState,
          product: req?.data,
          ready: true,
        }));
      }
    };

    if (!ready) $onLoad(match?.params?.id);
  }, []);

  return (
    <Page type="form" className="bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Perbaharui Item" />

      <Page.Body className="d-block row px-3">
        <div className="mt-3">
          <div className="row">
            <div className="col-md-6 border-end pe-md-4 pe-0">
              <FormInput product={product} onInputChange={$handleFormChange} />
            </div>
            <div className="col-md-6 px-md-4 px-0">
              <FormUnit datas={product?.units} onInputChange={$handleUnitChange} />
            </div>
          </div>
        </div>
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap nzindex">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/master/product`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
